import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import '@/assets/css/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-default/index.css';
// import './assets/style/theme.less';
import './plugins/systemPreload';
import App from './App.vue';
import store from './store';
import RegionPicker from 'region-picker';
import 'region-picker/dist/region-picker.css';
import './assets/style/client.css';
import router from './router';
// import WS from './services/ws.js';
import * as filters from './filters';
import { ws, url } from './plugins/ws';
import { byteLength, calcDeductionAmount } from './utils';
import materialLibrary from '@/components/materialLibrary/index.js';
import balanceBar from '@/components/balanceBar.vue';
import smsAssets from '@/components/smsAssets/index.vue';
import interactionSetBar from '@/components/interaction/setBar.vue';
import vcolorpicker from 'vcolorpicker';
import TabPopover from '@/components/common/tabPopover';
import UpgradePopoverTips from '@/components/videoLive/upgradePopoverTips';
import UpgradeTip from '@/components/common/upgradeTip';
import './plugins/rxjs';
import '@/assets/style/customClass.less';
import errorHandler from './plugins/errorHandler';
import '@/micro-fe';
import commonRouter from './router/commonRouter';

// 模拟数据，接口出来后删除
// import './mock';
Vue.config.errorHandler = errorHandler;
Vue.prototype.$byteLength = byteLength;
Vue.prototype.$calcDeductionAmount = calcDeductionAmount;
Vue.use(vcolorpicker);
Vue.use(ElementUI, { locale });
Vue.use(VueRouter);
Vue.use(RegionPicker);
Vue.use(ws, url);
Vue.use(materialLibrary);
Vue.component('TabPopover', TabPopover);
//升级直播间提示
Vue.component('UpgradePopoverTips', UpgradePopoverTips);
// 提示内容
Vue.component('UpgradeTip', UpgradeTip);

Vue.component('BalanceBar', balanceBar);
Vue.component('SmsAssets', smsAssets);
Vue.component('InteractionSetBar', interactionSetBar);

// 定义全局过滤器
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key]);
});

store.registerModule('app', {
	state: {
		isLoading: false,
		dataLoading: false,
	},
	mutations: {
		updateLoadingStatus(state, payload) {
			state.isLoading = payload.isLoading;
		},
		updateDataLoading(state, payload) {
			state.dataLoading = payload.loading;
		},
	},
	actions: {
		updatePosition({ commit }, top) {
			commit({ type: 'updatePosition', top });
		},
	},
});

let app = new Vue({
	data() {
		return {
			customDataEntry: false,
		};
	},
	store,
	router,
	render: (h) => h(App),
});

Promise.all([store.dispatch('saveUser'), store.dispatch('company/getCompanyAndStoreList')]).then(() => {
	app.$mount('#app');
	if (!app.$store.state.userInfo.user.id) {
		router.push({ name: 'login' });
	}
});

router.beforeEach((to, from, next) => {
	const paymenu = [
		'mylive.teamManage',
		'mylive.dataStatistics',
		'mylive.specialShare.wxShare',
		'mylive.specialShare.invite',
		'mylive.interaction',
	];
	const companyMenu = [
		'user.information',
		'information.basic',
		'information.configGlobal',
		'information.domain',
		'information.subscription',
		'information.wechatPay',
		'user.subaccount',
		'user.promoter',
		'user.advanced',
		'advanced.configGlobal',
		'serviceAccess.commerBridge',
		'user.advanced.configGlobal',
		'user.advanced.configGlobal.companyLogo',
		'user.advanced.configGlobal.companyLive',
		'user.advanced.configGlobal.publish',
	];
	const confirmmenu = [
		'我的直播',
		// '直播设置',
		'视频直播',
		'团队管理',
		'直播发布',
		'授权管理',
		'数据统计',
		'定制分享',
		'评论管理',
	];
	console.log('beforeEach', to.name);
	if (!app.$store.state.userInfo.user.id && !commonRouter.map((item) => item.name).includes(to.name)) {
		next('/login');
	} else if (
		companyMenu.includes(to.name) &&
		!app.$store.getters.isCompany &&
		!app.$store.state.company.isCompanyMode
	) {
		// 企业版判断 自己没有企业版，并且不是企业版模式，禁止进入该路由
		app.$store.dispatch('company/updateCompany');
		next(false);
		return;
	} else if (app.$store.state.userInfo.level && app.$store.state.userInfo.level >= 1) {
		next();
		return;
	} else if (paymenu.includes(to.name) && app.$store.state.state.currentActive.isPay == 0) {
		app.$store.dispatch('updateMajor', app.$children[0].$children[0].$children[0]);
		app.$root.$emit('restart-nav');
	} else {
		next();
	}
});

if (location.pathname.indexOf('/remote') > -1) {
	location.href = location.protocol + '//' + location.host;
}
